import dayjs from 'dayjs'

/**
 * 翌月1日を取得する関数
 */
export const getFirstDayOfNextMonth = (): string => {
  return dayjs().add(1, 'month').startOf('month').format('YYYY.MM.DD')
}
